var map = {
	"./header.en.json": [
		53743,
		3743
	],
	"./header.es.json": [
		80756,
		756
	],
	"./header.ja.json": [
		14401,
		4401
	],
	"./header.ko.json": [
		26106,
		6106
	],
	"./header.ms.json": [
		20716,
		716
	],
	"./header.th.json": [
		18588,
		8588
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65079;
module.exports = webpackAsyncContext;